import { Box } from '@mui/material';

import { EnumUserType, User } from 'lib/graphql';

import { CustomerForm } from 'features/customers/components/customer-form/customer-form';

import { SplitSlotDrawer } from '../../../shared/split-slot/split-slot-drawer';

interface NewBuyerDrawerProps {
  open: boolean;
  vendorId: string;
  producerId: string;
  onCreated: (user: User) => void;
  onClose: () => void;
}

export function NewBuyerDrawer({
  open,
  vendorId,
  producerId,
  onCreated,
  onClose,
}: NewBuyerDrawerProps) {
  return (
    <SplitSlotDrawer open={open} title="Add New Buyer" onClose={onClose}>
      <Box sx={{ flex: 1, overflow: 'auto', p: 2 }}>
        <CustomerForm
          forcedType={EnumUserType.Buyer}
          context="scheduling-contact"
          presetProducerId={producerId}
          vendorId={vendorId}
          isInDialog
          showActions
          onSuccess={(created) => {
            onCreated(created);
            onClose();
          }}
          onCancel={onClose}
        />
      </Box>
    </SplitSlotDrawer>
  );
}
